"use client";

import { useEffect } from "react";

const PAGESENSE_SRC =
  "https://cdn.pagesense.io/js/pickcel/90bf067904954a2286e58152fb9d571e.js";
const SCRIPT_ID = "pagesense-script";
/** Keep PageSense off the early TBT window. */
const MIN_DELAY_MS = 5000;

function injectPageSense() {
  if (typeof document === "undefined") return;
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.type = "text/javascript";
  script.async = true;
  script.src = PAGESENSE_SRC;
  document.head.appendChild(script);
}

/**
 * Defers Zoho PageSense (and its session-recording payload) until the user
 * interacts or at least MIN_DELAY_MS has passed — keeps it off the critical TBT path.
 */
export default function PageSenseScript() {
  useEffect(() => {
    let loaded = false;
    let timeoutId: number | undefined;

    const load = () => {
      if (loaded) return;
      loaded = true;
      cleanup();
      injectPageSense();
    };

    const onInteraction = () => load();

    const cleanup = () => {
      if (timeoutId !== undefined) window.clearTimeout(timeoutId);
      window.removeEventListener("scroll", onInteraction);
      window.removeEventListener("pointerdown", onInteraction);
      window.removeEventListener("keydown", onInteraction);
      window.removeEventListener("touchstart", onInteraction);
    };

    window.addEventListener("scroll", onInteraction, { once: true, passive: true });
    window.addEventListener("pointerdown", onInteraction, { once: true });
    window.addEventListener("keydown", onInteraction, { once: true });
    window.addEventListener("touchstart", onInteraction, { once: true, passive: true });

    timeoutId = window.setTimeout(load, MIN_DELAY_MS);

    return cleanup;
  }, []);

  return null;
}
